import $ from 'jquery'
import 'slick/slick.css'
import 'slick-carousel'

window.addEventListener('load', () => {
  $('#js-mv-slider').slick({
    autoplay: true,
    arrows: false,
    fade: true,
    autoplaySpeed: 4000,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false
  })
})
